import type { CSSProperties, FC, HTMLAttributes } from 'react'
import { useState } from 'react'
import { PulseProgressBox } from '../progress/index.js'

interface ImageProps extends HTMLAttributes<HTMLDivElement> {
  url?: string
  className?: string
  rotation?: number
}

export const Image: FC<ImageProps> = props => {
  const { url, className, rotation = 0, ...divProps } = props

  const [loaded, setLoaded] = useState(false)

  const handleLoad = () => {
    setLoaded(true)
  }

  const style: CSSProperties = className
    ? {
        transform: `rotate(${rotation}deg)`,
      }
    : {
        transform: `rotate(${rotation}deg)`,
        width: '100%',
        objectFit: 'cover',
      }

  return (
    <div {...divProps}>
      {url && (
        <img key={url} className={className} onLoad={handleLoad} style={style} src={url} contentEditable={false} />
      )}

      {!loaded ? <PulseProgressBox title="Loading image - please wait..." /> : null}
    </div>
  )
}
